import { render, staticRenderFns } from "./PersonalClientRow.vue?vue&type=template&id=03662894"
import script from "./PersonalClientRow.vue?vue&type=script&lang=js"
export * from "./PersonalClientRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports